/**
 * Modal enter motion (.claude/skills/review-animations/STANDARDS.md): the backdrop fades in and the
 * panel fades in from scale 0.96, 200ms on the strong ease-out, origin CENTER (modals are exempt from
 * trigger-origin scaling). Pure CSS via @starting-style (Tailwind `starting:`), so no state, no JS and
 * nothing on the server. Reduced motion keeps the fade and drops the scale.
 *
 * There is no exit animation on purpose: every modal here unmounts on close, and the close is the
 * user's own action, so an instant close reads as responsive rather than abrupt.
 *
 *   <div className={`fixed inset-0 … ${MODAL_BACKDROP}`}><div className={`… ${MODAL_PANEL}`}>…</div></div>
 *
 * Frequent, keyboard-driven popovers (the item search dropdown) stay instant: see the frequency table
 * in STANDARDS.md.
 */
export const MODAL_BACKDROP = 'transition-opacity duration-200 ease-out starting:opacity-0';
export const MODAL_PANEL =
  'transition-[opacity,scale] duration-200 ease-out starting:opacity-0 motion-safe:starting:scale-[0.96]';
